import React, { ForwardedRef, forwardRef, HTMLAttributes, ReactNode, RefObject, useEffect, useRef, useState } from 'react';
import './SlideDown.css';
import { useWidthContext } from '../../providers/Width';

interface ISlideDownProps {
    children: ReactNode;
    open?: boolean;
    className?: string;
    // onTransitionEnd?: GlobalEventHandlers["ontransitionend"];
    as?: 'div' | 'p' | 'span';
}

const SlideDown = forwardRef(({
    open = false,
    children,
    className,
    as,
    ...rest
}: ISlideDownProps & HTMLAttributes<HTMLParagraphElement | HTMLDivElement | HTMLSpanElement>, ref: ForwardedRef<HTMLDivElement>) => {

    const Tag = (as ? as : 'div');
    const slideHolderRef = useRef(null);

    const [animateOpen, setAnimateOpen] = useState(false);
    const [slideHeight, setSlideHeight] = useState<undefined | number>();
    const { width } = useWidthContext();

    useEffect(() => {
        if (open && !animateOpen) {
            setAnimateOpen(true);
        } else if (!open && animateOpen) {
            setAnimateOpen(false);
        }
    }, [open]);

    useEffect(() => {
        let slideHolder = (slideHolderRef as RefObject<HTMLDivElement>).current;
        if (slideHolder !== null) {
            const height = slideHolder.getBoundingClientRect().height / 16; // Convert to rem
            if (height && height !== slideHeight) {
                setSlideHeight(height);
            }
        }
    }, [width, open]);

    return (
        <Tag
            ref={ref}
            className={`SlideDown${className ? ' ' + className : ''}${animateOpen ? ' open' : ' closed'}`}
            tabIndex={-1}
            aria-hidden={!animateOpen}
            style={slideHeight ? {
                transition: `${slideHeight / 60}s max-height ease-in-out`,
            } : undefined}
            {...rest}
        >
            <div ref={slideHolderRef}>
                {children}
            </div>
        </Tag>
    );
});

export default SlideDown;